module.exports = __webpack_public_path__ + "img/plan_4.f62ff2d3.webp";